module.exports = "<p>\n  nf404 works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/pos/home/nf404/nf404.component.html
// module id = ../../../../../src/app/pos/home/nf404/nf404.component.html
// module chunks = main